export default __webpack_public_path__ + "static/media/filter-results.377b9425.svg";